import { CheckCircle, KeyboardDoubleArrowDown } from "@mui/icons-material"
import { useSelector } from "react-redux";
import { useState } from "react";


const SyncingProgress = () => {
    const [isExpanded, setIsExpanded] = useState(true);
    let { data, totalFile, type } = useSelector(state => state.fileManagement);
    return (
        <>
            <div
                id='syncing'
                className='pf bg1 shadow'
                style={{
                    zIndex: '9999',
                    left: "10px",
                    bottom: "0px",
                    borderRadius: "16px 16px 0px 0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: '350px'
                }}>

                <div
                    className="syncingProgressHeader tal df aic jcsb w100 pl1rem"
                    style={{
                        height: '60px',
                        borderBottom: '1px solid #eaeaea'
                    }}
                >
                    <h3 className="c15 fs1rem">
                        {
                            type === "syncingFolders" ? "Please wait while we create sub folders in your data room..." : <>
                                {type === "syncing" ? (data.filter(({ file }) => (file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem'])).length || "0") : (data.filter((d) => d['processed']).length || "0")} out of {totalFile} {type === "syncing" ? 'files' : "answers"} are {type === "syncing" ? type : "sync in reverse"}
                            </>
                        }

                    </h3>
                    <div className="df aic jcfe">
                        {
                            type === "syncingFolders" ? <></>
                                : <div
                                    className="cp px1rem br50px c15 df aic"
                                    onClick={() => setIsExpanded(!isExpanded)}
                                    style={{
                                        transition: 'transform 0.3s ease',
                                        transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'
                                    }}
                                >
                                    <KeyboardDoubleArrowDown />
                                </div>
                        }

                        {/* <div className="cp px1rem br50px c15 df aic" onClick={() => dispatch(resetSyncing())}>
                            <Close />
                        </div> */}
                    </div>
                </div>


                <div
                    className="w100 scrollbarWidth"
                    style={{
                        maxHeight: type === "syncingFolders" ? '0' : isExpanded ? '250px' : '0px',
                        overflowY: 'auto',
                        transition: 'max-height 0.3s ease, opacity 0.3s ease',
                        opacity: isExpanded ? 1 : 0
                    }}
                >
                    {
                        data && data.length ? type === "syncingFolders" ? <>
                        </> : type === "syncing" ? data.map(({ file, answer }, ind) => {
                            let image = require('../../../../images/fileTypes/pptxIcon.png')
                            const fileType = file.originalname.split('.').pop().toLowerCase()
                            if (fileType === 'pdf') image = require('../../../../images/fileTypes/pdfIcon.png')
                            if (fileType === 'pptx') image = require('../../../../images/fileTypes/pptxIcon.png')
                            if (fileType === 'xlsx') image = require('../../../../images/fileTypes/xlsxIcon.png')
                            return (
                                <div key={`syncing-file-${ind}-${answer.qNo}-${file.key || file.originalname}`} className={`df aic jcsb py1rem w100 px1rem ${!(file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem']) && "op60"}`}>
                                    <div className="df aic">
                                        <img style={{ marginRight: '8px' }} src={image} alt="fileType" />
                                        <p className="c15 fs14px">{answer.qNo} - {file.originalname}</p>
                                    </div>

                                    {
                                        (file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem']) ? <CheckCircle width={20} height={20} className="green" /> : <div>
                                            <span className="br50px bw2px bss db" style={{ height: '20px', width: '20px', borderColor: '#d0cfcfff' }}></span>
                                        </div>
                                    }

                                </div>
                            )
                        }) : type === "reSyncing" ? data.map((answer, ind) => {
                            return (
                                <div key={`syncing-file-${ind}-${answer.qNo}-${answer['_id']}`} className={`df aic jcsb py1rem w100 px1rem ${!answer['processed'] && "op60"}`}>
                                    <div className="df aic">
                                        <p className="fs10px bg4 br50px c1 p0-5rem df aic jcc" style={{ height: '32px', width: '32px' }}>SEC</p>
                                        <p className="c15 fs14px ml1rem">{answer.qNo} </p>
                                    </div>

                                    {
                                        answer['processed'] ? <CheckCircle width={20} height={20} className="green" /> : <div>
                                            <span className="br50px bw2px bss db" style={{ height: '20px', width: '20px', borderColor: '#d0cfcfff' }}></span>
                                        </div>
                                    }

                                </div>
                            )
                        }) : null : null
                    }

                </div>


            </div >
        </>
    )
}

export default SyncingProgress